import { render, staticRenderFns } from "./PemutakhiranPerubahanKkprl.vue?vue&type=template&id=00f2b8cc&scoped=true&"
import script from "./PemutakhiranPerubahanKkprl.vue?vue&type=script&lang=js&"
export * from "./PemutakhiranPerubahanKkprl.vue?vue&type=script&lang=js&"
import style0 from "./PemutakhiranPerubahanKkprl.vue?vue&type=style&index=0&id=00f2b8cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f2b8cc",
  null
  
)

export default component.exports